import * as THREE from 'three';
import { ParticlesSystem } from "./ParticlesSystem";

export class ButtonParticles {
    constructor({ model }) {
        // particles
        const emitterGeom = new THREE.PlaneGeometry(0.02, 0.02);
        const particleGeom = new THREE.PlaneGeometry(0.01, 0.01);
        const particleMat = new THREE.MeshBasicMaterial({
            color: new THREE.Color(0xffffff),
            transparent: true,
            opacity: .2,
            blending: THREE.AdditiveBlending,
        });

        const emitterMat = new THREE.MeshBasicMaterial({
            color: new THREE.Color(0x00ff00),
            transparent: true,
            opacity: 1,
        });

        this._emitter = new THREE.Mesh(emitterGeom, emitterMat);
        model.add(this._emitter);

        const particle = new THREE.Mesh(particleGeom, particleMat)
        this._emitter.position.set(0, 0, 0);
        this._emitter.geometry.applyMatrix4(new THREE.Matrix4().makeRotationX(Math.PI / 2))

        this.particlesSystem = new ParticlesSystem({
            name: "uiPanel",
            scene: model,
            count: 100,
            useLocal: true,
            emitter: this._emitter,
            followNormal: false,
            particle,
            particleMaxDelay: .4,
            particleLife: 2,
            particleLifeVariation: .3,
            particleTransSpeed: new THREE.Vector3(0, 0.08, 0),
            particleScaleSpeed: new THREE.Vector3(-1, -1, -1),
            emitterVisible: false,
            oneShot: true,
        })

        this.particlesSystem.createParticles();
    }

    moveEmitterToMarker(target) {
        this.updateEmitter({ scale: 1, target });
    }

    moveEmitterToHover(target) {
        this.updateEmitter({ scale: 2, target });
    }

    updateEmitter({ scale, target }) {
        this.emitter.scale.set(scale, scale, scale);
        this.emitter.position.copy(target.model.position);
        this.restart();
    }

    update(deltaTime) {
        this.particlesSystem.updateParticles(deltaTime);
    }

    restart() {
        this.particlesSystem.restartAll();
    }

    get emitter() {
        return this._emitter;
    }
}